module.exports = __webpack_public_path__ + "img/M_map_4.b28dbb45.png";